<template>
  <div class="car-form-container car-vehicle-identification-hsn-tsn">
    <div class="car-vehicle-identification-form">
      <hsn-tsn-form :stateObject="stateObject"
                    class="car-subform-container"
                    :form="form"
                    :validations="$v">
      </hsn-tsn-form>
      <div class="car-form-error-message " v-if="requestError">{{ $t('errors.unknown') }}</div>
      <div class="car-form-error-message" v-if="stateObject.vehicle.emptyResponse">
        {{$t('hsnTsnIdentification.errors.hsnTsnEmptyResponse')}}
      </div>
      <div class="car-form-buttons car-buttons">
        <primary-btn
          @click="getVehicles"
          class="car-btn-primary"
          :loading="stateObject.vehicle.loading"
          data-js="hsn-tsn__btn--get-vehicles">
          {{ $t('hsnTsnIdentification.getVehiclesBtn') }}
        </primary-btn>
        <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
      </div>

      <div class="car-spinner-container"><spinner v-if="stateObject.vehicle.loading" class="car-spinner car-content-spinner" /></div>

      <div class="car-subform-container" v-if="vehicles.length">
        <div class="car-section-text">
          <span class="car-subheadline">{{ $t('hsnTsnSelection.titleMoreInfo') }}</span>
          <p>{{ $t('hsnTsnSelection.descriptionMoreInfo') }}</p>
        </div>
        <hsn-tsn-vehicle-form :form="form2"
                              :vehicles="vehicles"
                              :equipments="equipments"
                              :stateObject="stateObject"
                              :years="years"
                              @selectYear="selectYear"
                              @selectVehicle="selectVehicle"
                              :validations="$v">
        </hsn-tsn-vehicle-form>
        <div class="car-form-item car-form-item-mileage">
          <label for="mileage">{{$t('vinIdentification.mileagePlaceholder')}}</label>
          <input type="text" id="mileage"
                 :class="{'car-filled': mileage}"
                 data-js="hsn-tsn__input--mileage"
                 :placeholder="$t('vinIdentification.mileagePlaceholder')"
                 v-model="mileage">
        </div>
      </div>
      <div class="car-form-error-message" v-if="requestError">{{ $t('errors.unknown') }}</div>
      <div class="car-form-buttons car-buttons" v-if="vehicles.length">
        <primary-btn
          @click="goNext"
          class="car-btn-primary"
          :loading="loading"
          data-js="hsn-tsn__btn--submit">
          {{ $t('catalogSelection.mainBtn') }}
        </primary-btn>
        <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import HsnTsnForm from '@/components/vehicleIdentification/HsnTsnForm';
import HsnTsnVehicleForm from '@/components/vehicleIdentification/HsnTsnVehicleForm';
import Moment from 'moment';
import _ from 'lodash';
import regionService from '@/services/regionService';
import smpConfigUtil from '@/util/smp_config_utils';
import PrimaryBtn from '@/components/PrimaryBtn';
import Spinner from 'vue-simple-spinner';
const { required, minLength } = require('vuelidate/lib/validators');

export default {
  name: 'HsnTsnSelection',
  data: function() {
    return {
      loading: false,
      requestError: false,
      mileage: this.$store.getters['wizardData/mileage'],
      form: {
        hsn: this.$store.getters['wizardData/hsnTsnData'].hsn,
        tsn: this.$store.getters['wizardData/hsnTsnData'].tsn
      },
      form2: {
        vehicle: this.$store.getters['wizardData/hsnTsnData'].vehicle,
        year: this.$store.getters['wizardData/hsnTsnData'].year,
        month: this.$store.getters['wizardData/hsnTsnData'].month,
        equipment: this.$store.getters['wizardData/hsnTsnData'].equipment
      },
      stateObject: {
        vehicle: {
          loading: false,
          requestError: false,
          emptyResponse: false
        },
        equipment: {
          loading: false,
          requestError: false,
          emptyResponse: false
        }
      }
    }
  },
  methods: {
    ...mapMutations('vehicleEquipments', {
      setEquipments: 'SET_SELECTED_EQUIPMENTS'
    }),
    ...mapMutations('vehicleIdentification', {
      clearVehicles: 'SET_VEHICLE_LIST_HSN_TSN',
      clearEquipments: 'SET_EQUIPMENTS_HSN_TSN'
    }),
    selectVehicle() {
      this.form2.year = null;
      this.form2.month = null;
      this.form2.equipment = null;
      this.clearEquipments([]);
    },
    selectYear() {
      this.clearErrors();
      this.form2.equipment = null;
      this.clearEquipments([]);
      this.stateObject.equipment.loading = true;
      this.$store.dispatch('vehicleIdentification/getEquipmentsHsnTsn', this.form2)
        .then(res => {
          if (!this.equipments.length) this.stateObject.equipment.emptyResponse = true;
          if (this.equipments.length === 1) {
            this.form.equipment = this.equipments[0];
          }
          return res;
        })
        .catch((err) => {
          this.stateObject.equipment.requestError = true;
          return Promise.reject(new Error(err));
        })
        .finally(() => {
          this.stateObject.equipment.loading = false;
        })
    },
    goNext() {
      this.clearErrors();
      this.$v.form2.$touch();
      if (this.$v.form2.$invalid || this.loading) { return; }
      this.loading = true;
      this.$store.dispatch('vehicleIdentification/setVehicleHsnTsn', this.form2);
      this.$store.dispatch('wizardData/setHsnTsnData', { ...this.form, ...this.form2 });
      this.$store.dispatch('wizardData/setMileageData', this.mileage);
      let equipments = this.$store.getters['vehicleIdentification/equipmentsHsnTsnNonRedundant'].find(e => e.ecode === this.form2.equipment.ecode);
      this.setEquipments(equipments.values);
      this.loading = false;
      regionService.nextRoute(this)
    },
    clearErrors: function() {
      this.stateObject.vehicle.emptyResponse = false;
      this.stateObject.vehicle.requestError = false;
      this.stateObject.equipment.emptyResponse = false;
      this.stateObject.equipment.requestError = false;
    },
    clearForm: function() {
      this.form2 = {
        vehicle: null,
        month: null,
        year: null,
        equipment: null
      }
    },
    getVehicles() {
      this.clearErrors();
      this.clearForm();
      this.clearVehicles([]);
      this.clearEquipments([]);
      this.$v.form.$touch();
      if (this.$v.form.$invalid || this.stateObject.vehicle.loading) { return }
      this.stateObject.vehicle.loading = true;
      this.$store.dispatch('vehicleIdentification/getVehiclesHsnTsn', this.form)
        .then(() => {
          if (!this.vehicles.length) this.stateObject.vehicle.emptyResponse = true;
          if (this.vehicles.length === 1) this.form.vehicle = this.vehicles[0];
        })
        .catch((err) => {
          this.stateObject.vehicle.requestError = true;
          return Promise.reject(new Error(err));
        })
        .finally(() => {
          this.stateObject.vehicle.loading = false;
        });
    }
  },
  validations: {
    form: {
      hsn: {
        required,
        minLength: minLength(4)
      },
      tsn: {
        required,
        minLength: minLength(3)
      }
    },
    form2: {
      vehicle: {
        required
      },
      year: {
        required
      },
      month: {
        required
      },
      equipment: {
        required
      }
    }
  },
  computed: {
    ...mapGetters('vehicleIdentification', {
      vehicles: 'vehicleListHsnTsn',
      equipments: 'equipmentsHsnTsnNonRedundant'
    }),
    years() {
      let arr = [];
      if (_.has(this, 'form2.vehicle.constructionTo')) {
        const constructionTo = Math.min(this.form2.vehicle.constructionTo, Moment().year());
        for (let i = this.form2.vehicle.constructionFrom; i <= constructionTo; i++) {
          arr.push(i);
        }
        return arr.reverse();
      }
      return arr;
    }
  },
  beforeRouteEnter(to, from, next) {
    return next(vm => {
      if (!smpConfigUtil.isVehicleSelectionMethodAllowed(smpConfigUtil.VEHICLE_SELECTION_HSN_TSN)) {
        vm.$router.push({ name: 'VehicleIdentification' });
      }
    })
  },
  components: {
    PrimaryBtn,
    HsnTsnVehicleForm,
    HsnTsnForm,
    Spinner
  }
}
</script>
